import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
// Common
import { inject, Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Pipes
import { DateByDayIndexPipe } from '@modules/utils/pipes/date-by-day-index.pipe';
import { DateFormatService } from '@modules/common/services/date-format.service';

// Types
import { VirtualFolder } from '../types/virtual-folder';

@Pipe({
  name: 'titleByTasksFilter',
  standalone: false,
  pure: false,
})
export class TitleByTasksFilterPipe implements PipeTransform {
  private readonly dateFormatService = inject(DateFormatService);

  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'all_tasks' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Tasks`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'search_results':
        return 'All Results';
      case 'following':
        return 'Following';
      case 'assigned_to_me':
        return 'Assigned to me';
      case 'all_tasks':
        return 'Tasks';
      case 'today':
        return 'Today';
      case 'week':
        return 'Next 7 days';
      case 'day0':
        return 'Tomorrow';
      case 'day1':
      case 'day2':
      case 'day3':
      case 'day4':
      case 'day5':
      case 'day6':
        const dateByDayIndexPipe = new DateByDayIndexPipe();
        const day = dateByDayIndexPipe.transform(value);
        return this.dateFormatService.formatDayOfWeek(day);
      case 'priority':
        return 'Priority';
      case 'low':
        return 'Low';
      case 'normal':
        return 'Normal';
      case 'high':
        return 'High';
      case 'flagged':
        return 'Flagged';
      case 'followed':
        return 'Follow Up';
      case 'overdue':
        return 'Overdue';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'all_projects':
        return 'Projects';
      case 'snoozed':
        return 'Snoozed';
      default:
        return checkExhaustiveness(value);
    }
  }
}
